<div class="flex justify-center items-center bg-gray-100 h-full">
  <div
   class="h-full w-full bg-white shadow-lg rounded-lg flex gap-8 pl-12 pt-12 pr-12 pb-4"
   [ngClass]="windowSize < 1024 ? 'justify-center' : 'justify-between'"
  >

    <div
      class="flex-col w-10/20 h-full"
      [ngClass]="windowSize < 1024 ? 'p-2' : 'p-16'"
    >
      <img
        src="assets/images/blue-logo-image.svg"
        alt="Logo"
        class="h-55 w-85"
      >
      <h2 class="text-2xl font-bold mb-2">Alterar senha</h2>
      <p class="text-gray-600 mb-8">Para alterar sua senha, insira uma nova senha e confirme-a em seguida.</p>

      <form class="flex flex-col space-y-8">
        <GenericInput
          [configs]="{
            formFieldType: 'outline',
            inputType: 'password',
            inputLabel: 'Nova senha',
            placeholder: 'Ex. Senha123@',
            inputValidators: getValidators('password'),
            labelClass: 'text-neutral-400',
            controlName: 'password',
            noLabel: false,
            class: '!w-full'
          }"
          [form]="form"
          class="w-full"
        >
        </GenericInput>
        <GenericInput
        [configs]="{
          formFieldType: 'outline',
          inputType: 'password',
          inputLabel: 'Confirmar senha',
          placeholder: 'Ex. Senha123@',
          inputValidators: getValidators('confirm_password'),
          labelClass: 'text-neutral-400',
          controlName: 'confirm_password',
          noLabel: false,
          class: '!w-full'
        }"
        [form]="form"
        class="w-full"
        >

        </GenericInput>
        <button
          mat-flat-button
          class="w-full submit-button"
          [disabled]="form.invalid"
          (click)=" loading ? null : setUserPassword()"
        >
          @if(loading) {
            <mat-spinner
              class="loading-spinner"
              diameter="40"
              color="#FFF"
            >
            </mat-spinner>
          } @else {
            Alterar senha
          }
        </button>
      </form>
    </div>

    <div
      class="w-full h-full"
      [ngClass]="windowSize < 1024 ? 'hidden' : ''"
    >
      <img
        src="assets/images/recover-password-page-image.png"
        alt="Vôlei"
        class="h-19/20 w-full rounded-lg object-cover"
      >
    </div>
  </div>
</div>
